import globals from '../globals/communityGlobals';

const locale = globals.getArea('externalProvider');

export const ExternalProviderOptions = [
  { id: 0, name: locale.getMsg('teamMapping'), key: 'teamMapping' },
  { id: 1, name: locale.getMsg('requestLogs'), key: 'requestLogs' },
  { id: 2, name: locale.getMsg('clinicianUsernameMapping'), key: 'clinicianUsernameMapping' },
  { id: 3, name: locale.getMsg('outcomeCodes'), key: 'outcomeCodes' },
];
